import { createApp } from "vue"

import "@/assets/index.css"

import App from "@/App.vue"
import datadog from "@/plugins/datadog/datadog.ts"
import routerFactory from "@/plugins/router"
import routesDefinition from "@/plugins/router/routes.ts"
import { VueQueryPlugin } from "@tanstack/vue-query"

const app = createApp(App)

app.provide("isStaging", __APP_IS_STAGING__)
app.use(VueQueryPlugin)
app.use(routerFactory(routesDefinition))
app.use(datadog, {
  envResolver: () => {
    if (__APP_VERCEL_BRANCH__ === "main") {
      return __APP_IS_STAGING__ ? "staging" : "production"
    }
    return __APP_VERCEL_BRANCH__
  },
})
app.mount("#app")
